import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Header from "./components/Header";
import Home from "./components/Home";
import Hosts from "./components/Hosts";
import Guests from "./components/Guests";
import ServiceProviders from "./components/ServiceProviders";
import Contact from "./components/Contact";
import Booking from "./components/Booking";
import Footer from "./components/Footer";
import LogoShowcase from "./components/LogoShowcase";

function App() {

  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/hosts" element={<Hosts />} />
          <Route path="/guests" element={<Guests />} />
          <Route path="/service-providers" element={<ServiceProviders />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/logo" element={<LogoShowcase />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
